module.exports = __webpack_public_path__ + "img/sw-ps-md.10d10a96.webp";